<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="formData" label-width="120px">
      <el-form-item label="买家账号:">
        <el-input size="small" v-model="formData.pin" placeholder="请输入买家账号" style="margin-right:80px"></el-input>
      </el-form-item>
      <el-form-item label="订单编号:" v-if="permissions.indexOf('hide:order:presellOrder') ==-1 ">
        <el-input
          size="small"
          v-model="formData.orderIdStr"
          @input="formData.orderIdStr = formData.orderIdStr.replace(/，/g, ',')"
          placeholder="请输入订单编号，多个请用','隔开"
          style="margin-right:80px"
        ></el-input>
      </el-form-item>

      <el-form-item label="订单金额:" class="range-num">
        <el-input
          size="small"
          v-model="formData.orderPaymentStart"
          placeholder="开始"
          @change="handleChangeSize(formData.orderPaymentStart, formData.orderPaymentEnd, 'orderPaymentEnd')"
        ></el-input>
        <span class="to">至</span>
        <el-input
          size="small"
          v-model="formData.orderPaymentEnd"
          placeholder="结束"
          @change="handleChangeSize(formData.orderPaymentStart, formData.orderPaymentEnd, 'orderPaymentEnd')"
          style="margin-right:80px"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付方式:" style="margin-right:90px">
        <el-select v-model="formData.payType">
          <el-option v-for="(item, index) in payTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态:" style="margin-right:90px">
        <!-- <el-select v-model="formData.orderState">
          <el-option v-for="(item, index) in orderStatusType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select> -->
        <el-input placeholder="请选择" v-model="orderStateLabel"></el-input>
        <div class="selectStateBox" @click="handleState"></div>
      </el-form-item>
      <el-form-item label="定金支付时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeStart"
            type="datetime"
            placeholder="选择开始日期时间"
            size="small"
            @change="handleDateSize(formData.orderStartTimeStart, formData.orderStartTimeEnd, 'formData.orderStartTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size:12px"
            :picker-options="pickerOptions0"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeEnd"
            type="datetime"
            placeholder="选择结束日期时间"
            size="small"
            @change="handleDateSize(formData.orderStartTimeStart, formData.orderStartTimeEnd, 'formData.orderStartTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions1"
            style="width: 145px; margin-right:80px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i
            class="el-icon-circle-close date_icon1"
            @click="(formData.orderStartTimeStart = ''), (formData.orderStartTimeEnd = '')"
            style="margin-right:80px"
          ></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" style="margin-right:80px" />
        </div>
      </el-form-item>
      <el-form-item label="商品名称:">
        <el-input size="small" v-model="formData.skuName" placeholder="请输入商品名称" style="margin-right:80px"></el-input>
      </el-form-item>
      <el-form-item label="商品SKU:" style="margin-right:80px">
        <!-- <el-input @focus="focusSku" size="small" v-model="formData.skuIds" placeholder="请输入商品SKU"></el-input> -->
        <inputSKU
          :sku.sync="formData.skuIds"
          style="margin-right:80px"
        ></inputSKU>
      </el-form-item>
      <el-form-item label="省份地区:" style="margin-right:90px">
        <div style="width: 280px">
          <el-button class="search" @click="showCityDialog">已选择{{ checkedList.length }}个</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn_group">
      <el-button size="small" :disabled="tableLoding" class="search" @click="submitForm('formSearch')">
        <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i>
        查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm">重置</el-button>
    </div>

    <city-popover v-model="cityShow" :checkedList="checkedList" @on-change="getLocation"></city-popover>
    <selectGoodsMonitor
      v-if="goodsState"
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    />
    <el-dialog title="订单状态" :visible.sync="orderStateData.visible">
      <el-checkbox :indeterminate="orderStateData.isIndeterminate" v-model="orderStateData.checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="orderStateData.checked" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in orderStatusType2" :label="item.value" :key="item.value" style="margin-bottom:15px;">{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <div class="btnBox">
        <el-button @click="handleStateSave" type="primary">确定</el-button>
        <el-button @click="orderStateData.visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import inputSKU from "@/components/Form/inputSKU.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import cityPopover from "@/components/city-popover-x.vue";
const allCheck = ["WAIT_PAYMENT", "WAIT_SELLER_STOCK_OUT", "WAIT_GOODS_RECEIVE_CONFIRM", "FINISHED_L", "TRADE_CANCELED", "LOCKED", "PAUSE"]; // 全选订单状态数据
export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
    orderStateLabel: {
      // 订单状态label
      type: String,
      default: () => "",
    },
  },
  components: {
    cityPopover,
    selectGoodsMonitor,
    inputSKU
  },
  computed:{
    permissions() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  data() {
    return {
      goodsState: false,
      returnSelectGoods: [],
      skuGoods: [],
      wareGoods: [],
      skuSearch: false, // 是否为sku搜索
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.formData.orderStartTimeEnd) {
            return time.getTime() > new Date(this.formData.orderStartTimeEnd).getTime();
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formData.orderStartTimeStart) {
            return time.getTime() < new Date(this.formData.orderStartTimeStart).getTime();
          }
        },
      },
      formData: {
        pin: "", // 空
        mobile: "", // 空
        orderIdStr: "",
        orderPaymentStart: "",
        orderPaymentEnd: "",
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 23:59:59",
        orderState: "",
        skuIds: "",
        orderRemarkContent: "",
        orderStateList: [],
      },
      // orderStatusType: [
      //   {
      //     label: '等待出库',
      //     value: 'WAIT_SELLER_STOCK_OUT'
      //   },
      //   {
      //     label: '发往配送中心（只适用于LBP，SOPL商家）',
      //     value: 'SEND_TO_DISTRIBUTION_CENER'
      //   },
      //   {
      //     label: '配送中心已收货（只适用于LBP，SOPL商家）',
      //     value: 'DISTRIBUTION_CENTER_RECEIVED'
      //   },
      //   {
      //     label: '等待确认收货',
      //     value: 'WAIT_GOODS_RECEIVE_CONFIRM'
      //   },
      //   {
      //     label: '收款确认（服务完成）（只适用于LBP，SOPL商家）',
      //     value: 'RECEIPTS_CONFIRM'
      //   },
      //   {
      //     label: '等待发货（只适用于海外购商家，等待境内发货 标签下的订单）',
      //     value: 'WAIT_SELLER_DELIVERY'
      //   },
      //   {
      //     label: '完成',
      //     value: 'FINISHED_L'
      //   },
      //   {
      //     label: '取消',
      //     value: 'TRADE_CANCELED '
      //   },
      //   {
      //     label: '已锁定',
      //     value: 'LOCKED'
      //   }
      // ],
      payTypeList: [
        {
          label: "货到付款",
          value: 1,
        },
        {
          label: "邮局汇款",
          value: 2,
        },
        {
          label: "自提",
          value: 3,
        },
        {
          label: "在线支付",
          value: 4,
        },
        {
          label: "公司转账",
          value: 5,
        },
        {
          label: "银行转账",
          value: 6,
        },
      ],
      tableLoding: false,
      checkedList: [],
      cityShow: false,
      mytimestart: "",
      mytimeend: "",

      orderStatusType2: this.orderStatusType.slice(1, 8), // 去除全部订单
      // 订单状态配置
      orderStateData: {
        isIndeterminate: false,
        checked: [],
        checkAll: false,
        visible: false,
        checkedLabel: "",
      },
    };
  },
  mounted() {
    // this.time();
    this.$emit("onSerach", this.formData);
  },
  methods: {
    // 保存订单状态
    handleStateSave() {
      var arr = [];
      this.orderStatusType2.forEach((e1) => {
        this.orderStateData.checked.forEach((e2) => {
          if (e1.value == e2) {
            arr.push(e1.label);
          }
        });
      });

      this.$emit("update:orderStateLabel", arr.length ? arr.join(",") : "");
      this.formData.orderStateList = this.orderStateData.checked.length ? this.orderStateData.checked : [];

      this.orderStateData.visible = false;
    },
    // 回显订单状态
    handleState() {
      var isState = this.formData.orderStateList.length;
      if (isState) {
        this.orderStateData.checked = this.formData.orderStateList;
        if (this.orderStateData.checked.length == 7) {
          this.orderStateData.isIndeterminate = false;
          this.orderStateData.checkAll = true;
        } else {
          this.orderStateData.isIndeterminate = true;
          this.orderStateData.checkAll = false;
        }
      } else {
        this.orderStateData.checked = [];
        this.orderStateData.isIndeterminate = false;
        this.orderStateData.checkAll = false;
      }

      if (this.orderStateLabel == "全部订单") {
        this.orderStateData.isIndeterminate = false;
        this.orderStateData.checkAll = false;
      }

      this.orderStateData.visible = true;
    },
    // 订单状态全选
    handleCheckAllChange(val) {
      var arr = [];
      this.orderStatusType2.map((e) => {
        arr.push(e.value);
      });
      this.orderStateData.checked = val ? arr : [];
      this.orderStateData.isIndeterminate = false;
    },
    // 选择订单状态
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.orderStateData.checkAll = checkedCount === this.orderStatusType2.length;
      this.orderStateData.isIndeterminate = checkedCount > 0 && checkedCount < this.orderStatusType2.length;
    },

    handleChangeSize(num1, num2, name) {
      if (num1 && num2) {
        if (Number(num2) <= Number(num1)) return (this.formData[`${name}`] = "");
      }
    },
    handleDateSize(date1, date2, name) {
      let oDate1 = new Date(date1);
      let oDate2 = new Date(date2);
      if (date1 && date2) {
        if (oDate1.getTime() >= oDate2.getTime()) return (this.formData[`${name}`] = "");
      }
    },
    getLocation(val, state) {
      if (state == "cancel") {
        return;
      }
      this.checkedList = val;
    },
    //           time() {
    // let yy = new Date().getFullYear(); //当前年份
    // let mm =
    //   new Date().getMonth() + 1 < 10
    //     ? "0" + (new Date().getMonth() + 1)
    //     : new Date().getMonth() + 1;
    // let dd =
    //   new Date().getDate() < 10
    //     ? "0" + new Date().getDate()
    //     : new Date().getDate(); //当前天数
    // this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
    // this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    // this.formData= {
    //   orderStartTimeStart: this.mytimestart, //提交时间开始
    //   orderStartTimeEnd: this.mytimeend, //提交时间结束
    //   sendStartTimeStart: this.mytimestart, //发送时间开始
    //   sendStartTimeEnd: this.mytimeend, //发送时间结束
    // }
    // },
    // 商品组件回调
    selectGoodsChange(val) {
      this.goodsState = false;
      if (val !== false) {
        // this.returnSelectGoods = val;
        var dataList = [];
        var skuList = [];
        val.forEach((item) => {
          dataList.push(item.wareId);
          skuList.push(item.skuId);
        });
        if (!this.skuSearch) {
          // 商品id
          this.wareGoods = val;
          // this.formData.wareIds = dataList.join(",");
        } else {
          // sku id
          this.skuGoods = val;
          this.formData.skuIds = skuList.join(",");
        }
      }
    },
    // focus() {
    //   this.skuSearch = false;
    //   this.returnSelectGoods = this.wareGoods;
    //   this.goodsState = true;
    // },
    // focusSku() {
    //   this.skuSearch = true;
    //   this.returnSelectGoods = this.skuGoods;
    //   this.goodsState = true;
    // },
    showCityDialog() {
      this.cityShow = true;
    },
    clearTimeSendTime() {
      this.formData.orderStartTimeStart = "";
      this.formData.orderStartTimeEnd = "";
    },
    submitForm() {
      console.log("111111111");
      // this.formData.province = this.checkedList.join(",");
      this.formData.cites = this.checkedList.join(",");
      this.$emit("onSerach", this.formData);
    },
    resetForm() {
      this.formData = {
        pin: "",
        mobile: "",
        orderIdStr: "",
        orderPaymentStart: "",
        orderPaymentEnd: "",
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 00:00:00",
        orderState: "",
        orderRemarkContent: "",
        skuName: "",
        orderStateList: [],
      };
      this.$emit("update:orderStateLabel", "全部订单");
      this.checkedList = [];
      this.$emit("onSerach", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 280px;
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.search {
  color: rgb(254, 77, 69);
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid rgb(254, 77, 69);
  font-size: 14px;
}
.search:hover {
  color: #ffffff;
  background-color: rgb(254, 77, 69);
}
.reset {
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.btn_group {
  text-align: center;
  .search {
    color: rgb(254, 77, 69);
    background-color: #ffffff;
    border: 1px solid rgb(254, 77, 69);
    font-size: 14px;
  }
  .search:hover {
    color: #ffffff;
    background-color: rgb(254, 77, 69);
  }
}
.selectStateBox {
  width: 280px;
  height: 32px;
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  position: absolute;
  top: 0;
}
.btnBox {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>
